<template>
  <v-dialog v-model="dialog" max-width="560" persistent>
      <template #activator="{on}">
        <v-btn icon v-on="on">
            <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
      <v-card v-if="step==0">
        <v-card-title>Are you sure ?</v-card-title>
        <v-card-text>Are you sure do you want delete this product ?</v-card-text>
        <v-card-actions>
            <v-btn @click="close">Cancel</v-btn>
            <v-spacer />
            <v-btn color="primary" @click="checkIfCanDelete">Delete</v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="step==1">
        <v-card-title>Not used</v-card-title>
        <v-card-text>This product isn't used in any prescription or order, you can delete it safely</v-card-text>
        <v-card-actions>
            <v-btn @click="close">Cancel</v-btn>
            <v-spacer />
            <v-btn color="primary" @click="confirmDelete">Delete</v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="step==2">
        <v-card-title>Used</v-card-title>
        <v-card-text>This product are used in a prescription or an order, you can't delete it.<br />Please desactivate it</v-card-text>
        <v-card-actions>
            <v-btn @click="close">Cancel</v-btn>
            <v-spacer />
            <v-btn color="primary" @click="desactivate">Desactivate</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    data: () => ({
        dialog:false,
        step:0,
    }),
    props:{
        product: {
            type: Number,
            required: true
        }
    },
    methods:{
        ...mapActions("products", {canDeleteProduct:'canDelete', deleteProduct:'deleteProduct', toggleActivate:'toggleActivate'}),
        checkIfCanDelete(){
            this.canDeleteProduct(this.product)
            .then(({canDelete}) => {
                if(canDelete){
                    this.step=1;
                }else{
                    this.step=2;
                }
            })
        },
        close(){
            this.step=0,
            this.dialog=false
        },
        confirmDelete(){
            this.deleteProduct(this.product)
            .then(() => {
                this.close()
                this.$emit("reload")
            })
        },
        desactivate(){
            this.toggleActivate(this.product)
            .then(() => {
                this.close()
                this.$emit("reload")
            })
        }
    }
}
</script>

<style>

</style>